import { ValueOf } from 'ts-pattern/dist/types/helpers';
import { UserRoleProfile } from '../api/zod-schemas';

export const availableLanguagesToIso6291Map: Record<string, string> = {
  en: 'en',
  ja: 'ja',
  jp: 'ja',
  es: 'es',
};

const formatUsernameBasedOnDisplayNameAndLocale: (
  firstName: string,
  lastName: string,
  displayName: string,
  languageId: string
) => string = (firstName, lastName, displayName, languageId) => {
  if (displayName) {
    return displayName;
  } else {
    if (firstName && lastName) {
      switch (languageId) {
        case 'ja':
          return lastName + ' ' + firstName;
        default:
          return firstName + ' ' + lastName;
      }
    }
  }
  return '';
};

export const formatUserBasedOnDisplayNameAndLocale: (
  currentUser: UserRoleProfile,
  languageId: string
) => string = (currentUser: UserRoleProfile, languageId: string) => {
  if (currentUser === null || currentUser === undefined) {
    return '';
  }
  return formatUsernameBasedOnDisplayNameAndLocale(
    currentUser.firstName ?? '',
    currentUser.lastName ?? '',
    '', // TODO: maybe revive displayName at some point
    languageId
  );
};

export function enumKeys<O extends object, K extends keyof O = keyof O>(
  obj: O
): K[] {
  return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
}

// Iterate through enumeration keys without loosing the type of the enumeration
// Without this, the type of each element would be string
export function enumValues<O extends object, V extends ValueOf<O> = ValueOf<O>>(
  obj: O
): V[] {
  return Object.values(obj) as V[];
}
